import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { WantedItem } from '../models/wanted-item.model';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WantedItemService {

  private _wantedItem: BehaviorSubject<WantedItem[]> = new BehaviorSubject([]);
  public readonly wantedItem: Observable<WantedItem[]> = this._wantedItem.asObservable();

  constructor(private api: ApiService) {
    this.loadWantedItem();
  }

  loadWantedItem() {
    this.api.getWantedItem().subscribe((wantedItem: WantedItem[]) => this._wantedItem.next(wantedItem));
  }

  saveWantedItem(wantedItem: WantedItem): Promise<any> {
    return new Promise((resolve, reject) => {
      if (wantedItem.id) {
        this.api.putData('wanted-item', wantedItem).subscribe((result: HttpResponse<any>) => {
          this.loadWantedItem();
          resolve(result.body as WantedItem);
        }, error => {
          this.loadWantedItem();
          reject(error);
        });
      } else {
        this.api.postData('wanted-item', wantedItem).subscribe((result: HttpResponse<any>) => {
          this.loadWantedItem();
          resolve(result.body as WantedItem);
        }, error => {
          this.loadWantedItem();
          reject(error);
        });
      }
    });
  }

  saveWantedItemFiles(wantedItem: WantedItem, files: File[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (wantedItem.id && files) {
        files.forEach((file, fileIndex) => {
          const fileFormData = new FormData();
          fileFormData.append('file', file);
          this.api.postData('wanted-item-image/' + wantedItem.id, fileFormData).subscribe(result => {
            if (fileIndex + 1 === files.length) {
              this.loadWantedItem();
              resolve(result);
            }
          }, error => {
            this.loadWantedItem();
            reject(error);
          });
        });
      } else {
        reject('no id');
      }
    });
  }

  deleteWantedItem(wantedItem: WantedItem): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.deleteData('wanted-item/' + wantedItem.id).subscribe(result => {
        this.loadWantedItem();
        resolve(result);
      }, error => {
        this.loadWantedItem();
        reject(error);
      });
    });
  }

  deleteWantedItemImages(wantedItemId: number, imageIds: number[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      imageIds.forEach((imageId, imageIndex) => {
        this.api.deleteData('wanted-item-image/' + wantedItemId + '/' + imageId).subscribe(res => {
          console.log('deleted image with id', imageId);
          if (imageIds.length === imageIndex + 1) {
            this.loadWantedItem();
            resolve();
          }
        });
      });
    });
  }
}
